// Dependecies
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';
import Button from 'react-bootstrap/Button';

// images
import iconCalendar from '../../../sass/images/business/icon-calendar-day.svg';
import search from '../../../sass/images/icons/search.svg';
import close from '../../../sass/images/icons/cerrar.svg';
import check from '../../../sass/images/icons/check.svg';
import notDashboard from '../../../sass/images/not-dashboard.svg';

// Components
import Template from '../../components/Template';
import ModalScheduling from '../../components/Modal/modalScheduling';
import PieDashboard from '../../components/PieDashboard';
import RadarDashboard from '../../components/RadarDashboard';
import BubbleDashboard from '../../components/BubbleDashboard';
import RadarDashboardVehicle from '../../components/RadarDashboardVehicle';
import BubbleDashboardVehicle from '../../components/BubbleDashboardVehicle';
import ListGroupDashboard from '../../components/ListGroupDashboard';
import ListGroupDashboardVehicle from '../../components/ListGroupDashboardVehicle';
import Spinner from '../../components/Spinner';
import FixedJobRequest from '../../components/JobRequest';
import VehiclesMapDashboard from '../../components/VehiclesMapDashboard';
import DashboardNotPlan from '../../components/DashboardNotPlan';

// Hooks
import useDashboardCompany from '../../hooks/useDashboardCompany';
import useNotificationRead from '../../hooks/useNotificationRead';

// Utils
import { contactEmail } from '../../helpers';

function dashboard() {
  const { newMaintenancesCompany } = useNotificationRead();
  const { t } = useTranslation(['dahsboard', 'alert', 'alt', 'routers']);
  const {
    company,
    totalService,
    totalServiceFinalized,
    totalTypesServices,
    valuePlate,
    chegeModal,
    openModal,
    redirect,
    imagen,
    searchLicensePlate,
    setValuePlate,
    closeModal,
    valuePlateDahsboard,
    errorPlate,
    lastService,
    reload,
    packagesCompany,
  } = useDashboardCompany();
  return (
    <Template
      type={4}
      newMaintenances={newMaintenancesCompany}
      classNameContainer="dashboardBusiness"
      className="container_menu dashboardBusiness"
    >
      <ModalScheduling isBlocked={openModal} close={closeModal} title="agendar" content="agendar" />

      {!reload ? (
        <Spinner text="cargando dashboard"> </Spinner>
      ) : (
        <>
          <FixedJobRequest />
          {!packagesCompany ? (
            <DashboardNotPlan company={company} />
          ) : (
            <>
              <div className="content_dynamic history company-block business">
                <Row className="content_history">
                  <div className="header-content">
                    <div className="info-tittle">
                      <h1 className="title-maintenances">Dashboard</h1>
                      <h3>
                        <strong>
                          {t('welcome')} {company}.
                        </strong>
                      </h3>
                      <p>{t('description')}</p>
                    </div>
                  </div>
                  <div className="convention-services">
                    <div className="type-status">
                      {!errorPlate ? (
                        <>
                          <h3>
                            <strong>{t('tittle2')}</strong>
                          </h3>
                          <p>{t('description2')}</p>
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                    <div className="modal-display company-content row-states dashboard-search">
                      <input
                        className="input_search form-control"
                        type="text"
                        placeholder={t('placeholder')}
                        value={valuePlate || ''}
                        onChange={(e) => {
                          setValuePlate(e.target.value.toUpperCase());
                        }}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          imagen === check
                            ? searchLicensePlate(valuePlate, close)
                            : searchLicensePlate('', check)
                        }
                      >
                        <img src={valuePlate ? imagen : search} alt={t('alt:search')} />
                      </button>
                    </div>
                  </div>
                </Row>
                {errorPlate ? (
                  <div className="content_not_mantenaice company dashboard">
                    <img
                      src={notDashboard}
                      className="img-not-maintenances small-dashboard"
                      alt={t('alt:not_mantenice')}
                    />
                    <p>
                      {t('not-dashboard')} <strong>{valuePlateDahsboard}</strong>.{' '}
                      {t('not-dashboard2')}
                      <a href={`mailto:${contactEmail()}`}>
                        <strong> {contactEmail()}. </strong>
                      </a>
                    </p>
                    <Button
                      className="btn-orange"
                      style={{ width: '250px', padding: '0px' }}
                      variant="light"
                      onClick={() => searchLicensePlate('', check)}
                    >
                      {t('button-dashboard2')}
                    </Button>
                  </div>
                ) : (
                  <>
                    <Row className="graphics no-gutters">
                      <Col xl={6} lg={12} md={12} sm={4}>
                        <Card className="block1">
                          <Card.Body>
                            <Row className="no-gutters">
                              <Col lg={5} xs={6} className="text_line">
                                <Card.Title className="data-title">{totalService}</Card.Title>
                                <Card.Subtitle> {t('requests_made')} </Card.Subtitle>
                              </Col>
                              <Col lg={5} xs={6} className="text_line">
                                <Card.Title className="data-title">
                                  {totalServiceFinalized}
                                </Card.Title>
                                <Card.Subtitle> {t('maintenance_performed')} </Card.Subtitle>
                              </Col>
                            </Row>
                            <div className="button_row">
                              <button
                                type="button"
                                className="button_card"
                                onClick={() => redirect(t('routers:JobsAgenda'), false, '')}
                              >
                                {t('see_more')}
                              </button>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col xl={3} lg={6} md={6} sm={4}>
                        <Card className="block2">
                          <Card.Body>
                            <Card.Title className="data-title">
                              {lastService ? (
                                <Moment format="DD/MM/YYYY">{lastService}</Moment>
                              ) : (
                                '- / - / -'
                              )}
                            </Card.Title>
                            <Card.Subtitle>{t('next_maintenance')}</Card.Subtitle>
                            <div className="button_row">
                              <button
                                type="button"
                                className="button_card"
                                onClick={() => redirect(t('routers:JobsAgenda'), false, '')}
                              >
                                {t('see_more')}
                              </button>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col xl={3} lg={6} md={6} sm={4}>
                        <Card className="block3 card-last-child">
                          <Card.Body>
                            <Card.Title>
                              <img alt="" src={iconCalendar} />
                            </Card.Title>
                            <Card.Subtitle>{t('dates_available_maintenance')}</Card.Subtitle>
                            <div className="button_row">
                              <button
                                type="button"
                                className="button_card"
                                onClick={() => chegeModal()}
                              >
                                {t('schedule')}
                              </button>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                    <Row className="graphics no-gutters">
                      <Col xl={4} lg={12} md={12} sm={4}>
                        <Card>
                          <Card.Body>
                            <Card.Title>{t('tittle2')}</Card.Title>
                            {valuePlateDahsboard ? (
                              <ListGroupDashboardVehicle plate={valuePlateDahsboard} />
                            ) : (
                              <ListGroupDashboard />
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col xl={8} lg={12} md={12} sm={8}>
                        <Card className="card-last-child">
                          <Card.Body>
                            <Card.Title> {t('maintenance_system')} </Card.Title>
                            <PieDashboard dataTypes={totalTypesServices} />
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                    <Row className="graphics no-gutters">
                      <Col xl={6} lg={12} md={12} sm={6}>
                        <Card>
                          <Card.Body>
                            <Card.Title> {t('vehicle_health')} </Card.Title>
                            {valuePlateDahsboard ? (
                              <RadarDashboardVehicle plate={valuePlateDahsboard} />
                            ) : (
                              <RadarDashboard />
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col xl={6} lg={12} md={12} sm={6}>
                        <Card className="card-last-child">
                          <Card.Body>
                            {valuePlateDahsboard ? (
                              <>
                                <Card.Title> {t('number_trips')} </Card.Title>
                                <BubbleDashboardVehicle plate={valuePlateDahsboard} />
                              </>
                            ) : (
                              <>
                                <Card.Title> {t('fleet_jobs_forecast')} </Card.Title>
                                <BubbleDashboard />
                              </>
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                    <Row className="graphics no-gutters">
                      <Col xl={12} lg={12} md={12} sm={12}>
                        <Card>
                          <Card.Body>
                            <Card.Title> {t('location_vehicle')} </Card.Title>
                            <VehiclesMapDashboard plate={valuePlateDahsboard} />
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
    </Template>
  );
}

export default dashboard;
